import { decrypt } from '@app/src/views/Login/login/helpers/encrypt';

export const hydrateData = (data) => {
  const decryptedPayload = decrypt(data.data)
  const { payload } = JSON.parse(decryptedPayload)
  let users = payload.map((user) => {
    return {
      fullName: user.fullName,
      state: user.state,
      userId: user.userId,
      email: user.email,
      role: user.role === 'administrador' ? 'Administrador' : 'Operador'
    }
  });

  let page = {
    total: 0,
    current: 0,
    totalRow: 0
  };

  page.total = data.metadata.pageTotal;
  page.current = data.metadata.page;
  page.totalRow = data.metadata.rowTotal;

  const dataHydrate = {
    code: data.code,
    message: data.message,
    data: users,
    page: page
  };

  return dataHydrate;
};
